<div class="image-dialog-container">
  <h2 class="dialog-title" [ngStyle]="{'color': titleColor}">{{ title | translate }}</h2>

  <div class="image-container">
    <img [src]="img" alt="Dialog image" class="dialog-image" (load)="imageLoaded()">
    <div *ngIf="!imageIsLoaded" class="image-placeholder"></div>
  </div>

  <p class="message">{{ message | translate }}</p>

  <div class="button-container">
    <button mat-flat-button [color]="buttonColor" (click)="close()">{{ buttonText | translate }}</button>
  </div>
</div>
